import React from 'react';
import { ScrollFrame } from '../components/ScrollFrame';
import { motion } from 'framer-motion';
import { PageTransition } from '../animations/PageTransition';
import { Helmet } from 'react-helmet';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

export const MainPage = ({ transition }) => {
	return (
		<motion.main className="main-page" exit={{ opacity: 0 }} transition={transition}>
			<Helmet>
				<title>Photo & Film Studio Rental in Stockholm – Spring Studio</title>
				<meta
					name="description"
					content="Spring Studio offers a versatile studio rental in Stockholm for photography, film, commercials, television productions, and music rehearsals."
				/>
				<meta property="og:title" content="Photo & Film Studio Rental in Stockholm – Spring Studio" />
				<meta
					property="og:description"
					content="Spring Studio offers a versatile studio rental in Stockholm for photography, film, commercials, television productions, and music rehearsals."
				/>
				<link rel="canonical" href="https://springstudio.se" />
			</Helmet>

			<PageTransition />
			<ScrollFrame text1="Spring Studio" text2="Now open" text3="Instrumentvägen 29" seperator="/" />
			<section className={'section section-hero-start'}>
				<div className={'row'}>
					<div className={'col col-12 offset-r-3 offset-l-1'}>
						<div className="module-text">
							<h1 className={'d1'} data-text="Spring Studio">
								Spring Studio
							</h1>
							<p className={'lg'}>
								Spring Studio is a versatile rental space in Aspudden/Örnsberg, just a three-minute walk from Örnsbergs metro station and close to Vinterviken’s cafés and
								waterfront. The studio is ideal for photography, film, commercial productions, music rehearsals, and creative projects of all kinds.
							</p>
						</div>
						<div className={'module-text button-wrapper'}>
							<a href="/studio" className="btn btn-primary btn-icon-after">
								Explore the studio <BsArrowRight />
							</a>
							<Link to="/contact" className="btn btn-secondary">
								Contact
							</Link>
						</div>
					</div>
				</div>
			</section>
		</motion.main>
	);
};
